import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    token: function(state) { return state.user.token },
    userInfo: function(state) { return state.user.userInfo },
    role: function(state) { return state.user.role },
    permissions: function(state) { return state.user.permissions },
    sidebar: function(state) { return state.user.sidebar },
    permissionRoutes: function(state) { return state.permission.routes },
    routesGenerated: function(state) { return state.permission.routesGenerated }
  },
  modules: { user: user, permission: permission }
})
